import React, { Component } from 'react'
import { Layout,Typography, Button }   from 'antd';
import efLogo from './assets/logo.svg';
import { ConfigProvider } from 'antd';
import bg from './assets/white_bg.svg';
//import miniQr from './assets/mini-qr.png';
import API from './api/api'
import Config from './config/pages'
const { Footer, Content } = Layout;
const { Title } = Typography;
//const efLogo = require('./assets/logo.svg')
const contentStyle: React.CSSProperties = {
  backgroundImage: `url(${bg})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center'
};
export default class About extends Component {
  /*state = {
    signout3rd: false
  }*/
  componentWillMount() {
        //console.log("signin mount",this.state.signout3rd)
        //const signout3rd = window.localStorage.getItem('signout3rd')?true:false
        //this.setState({signout3rd})
        //window.localStorage.removeItem("signout3rd")
    }
    render() {
        return (
          <ConfigProvider theme={{token:{colorPrimary:'#FF329B',colorLink:'#FF329B'},}}>
            <Layout >
              {/*<Header  className="bg-zinc-200 h-[60px] p-[5px]">
                <img className="h-full"  src={efLogo}></img>
              </Header>*/}
              
              <Content  className="h-[calc(100vh-40px)] flex justify-center items-center bg-zinc-200"  style={contentStyle}>
                <div className="w-[360px] min-h-[360px] bg-white rounded-3xl flex items-center justify-top flex-col p-10 shadow-xl">
                  <div  className="flex justify-center items-center  flex-col">
                    <Title level={3}>WELCOME</Title>
                    <img className="w-[100px]"  src={efLogo} alt="logo"></img>
                    <Title level={5}><p>欢迎使用英孚教育青少儿BOSS系统</p></Title>
                    <Button  type="primary" block    size="large"  href={API.login+"?page=index"} onClick={()=>{window.localStorage.setItem("signin1st","1")}}>点击登录</Button>
                  </div>
                  {/*<div className="flex justify-center items-center  flex-col pt-10">
                    <Text type="secondary"  className="text-xs">手机端BOSS系统使用微信扫描小程序码</Text>
                    <img className="h-40 w-40" alt="mini program" src={miniQr}/>
                  </div>*/} 
                </div>
              </Content>
              <Footer className="p-0 h-[40px] bg-[#555] text-white text-xs font-thin flex justify-center items-center">使用Boss系统过程中遇到任何问题，请Teams上联系技术支持：Landy.Wang、Zarks.Zhang</Footer>
              {/*this.state.signout3rd?
                Config.SIGNOUT_3RD_URL.map(url=>{
                  return <iframe src={url} className='hidden' width={0} height={0} title="hidden" />
                }):''
              */}
            </Layout>
          </ConfigProvider>
        )
    }
}